/* eslint-disable prettier/prettier */
<template>
  <div class="padding-10">
    <v-card
      class="white-background padding-5"
      :elevation="$root.ele"
      v-if="!isLoading"
    >
      <v-form v-model="isValid" ref="form">
        <Form v-model="form"></Form>
      </v-form>
      <Footer :item="user" @update="update" @save="save"></Footer>
    </v-card>
  </div>
</template>

<script>
import Form from "./create/Form.vue";
import Footer from "./create/Footer";
import { auth, carMakeUnlocking } from "../../assets/js/firebase";
import { getDate } from "../../assets/js/common";

export default {
  components: {
    Footer,
    Form
  },
  data() {
    return {
      isValid: false,
      isLoading: true,
      form: {
        name: "",
        make_id: "",
        models: []
      },
      user: {}
    };
  },
  methods: {
    async save() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let date = getDate();
        let lower = form.name.toLowerCase();
        form.created_at = date;
        form.name_lower = lower;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let snap = await carMakeUnlocking
          .where("name_lower", "==", lower)
          .limit(1)
          .get();
        let snapId = await carMakeUnlocking
          .where("make_id", "==", form.make_id)
          .limit(1)
          .get();
        if (!snap.empty) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same name");
          return;
        }
        if (!snapId.empty) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same ID");
          return;
        }
        await carMakeUnlocking.add(form);
        vm.$root.loader = false;
        vm.$router.replace("/car-make-unlocking");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async update() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let lower = form.name.toLowerCase();
        let date = getDate();
        form.created_at = date;
        form.name_lower = lower;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let { id } = vm.$route.params;
        let snap = await carMakeUnlocking
          .where("name_lower", "==", lower)
          .limit(1)
          .get();
        let snapId = await carMakeUnlocking
          .where("make_id", "==", form.make_id)
          .limit(1)
          .get();
        if (!snap.empty && snap.docs[0].id != id) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same name");
          return;
        }
        if (!snapId.empty && snapId.docs[0].id != id) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same ID");
          return;
        }
        await carMakeUnlocking.doc(id).update(form);
        vm.$root.loader = false;
        vm.$router.replace("/car-make-unlocking");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async init() {
      const vm = this;
      let { name, params } = vm.$route;
      if (name === "car-make-unlocking-update") {
        let { id } = params;
        vm.$root.loader = true;
        try {
          let user = await carMakeUnlocking.doc(id).get();
          vm.$root.loader = false;
          if (!user.exists) {
            vm.$root.alert("Make not found");
            vm.$router.replace("/car-make-unlocking");
            return;
          }
          let { name, models, make_id } = user.data();
          if (!make_id) make_id = "";
          vm.form = { name, models, make_id };
          vm.isLoading = false;
        } catch (error) {
          vm.$root.loader = false;
          vm.$root.alert(error.message);
        }
      } else {
        vm.isLoading = false;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style></style>
